/**
 * External Dependencies
 */
import 'jquery';
import 'slick-carousel';
import AOS from 'aos';
import Parallax from 'parallax-js';



$(document).ready(() => {
  // console.log('Hello world');
  
  // function HandleBackFunctionality()
  // {
  //       if(window.event) //Internet Explorer
  //       {
  //           console.log("Browser back button is clicked on Internet Explorer...");
  //           $('body').removeClass('animation--out');
  //           window.reload();
  //       }
  //       else //Other browsers e.g. Chrome
  //       {
  //           console.log("Browser back button is clicked on other browser...");
  //           $('body').removeClass('animation--out');
  //           window.reload();
  //       }
  // }

  if ($("body").hasClass("home") == true && !sessionStorage.getItem('hasVisited')) {
    $('body').addClass('animation--in');
    $('body').addClass('animation');

    setTimeout(function(){
      $("html, body").animate({ scrollTop: 0 }, "slow");
      $('body').addClass('animation-done');
     
      setTimeout(function(){ 
        AOS.init({
          // Global settings:
          disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
          startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
          initClassName: 'aos-init', // class applied after initialization
          animatedClassName: 'aos-animate', // class applied on animation
          useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
          disableMutationObserver: false, // disables automatic mutations' detections (advanced)
          debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
          throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
          
          // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
          offset: 240, // offset (in px) from the original trigger point
          delay: 0, // values from 0 to 3000, with step 50ms
          duration: 350, // values from 0 to 3000, with step 50ms
          easing: 'ease', // default easing for AOS animations
          once: true, // whether animation should happen only once - while scrolling down
          mirror: false, // whether elements should animate out while scrolling past them
          anchorPlacement: 'top-center', // defines which position of the element regarding to window should trigger the animation
        });
      }, 1000);
    }, 2600);
    sessionStorage.setItem('hasVisited', true); 
  }
  else {
    $('body').addClass('loader-home-cookie-on');
    $('body').addClass('animation--in');
    setTimeout(function(){
      $("html, body").animate({ scrollTop: 0 }, "slow");
      AOS.init({
        // Global settings:
        disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
        startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
        initClassName: 'aos-init', // class applied after initialization
        animatedClassName: 'aos-animate', // class applied on animation
        useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
        disableMutationObserver: false, // disables automatic mutations' detections (advanced)
        debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
        throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
        
        // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
        offset: 40, // offset (in px) from the original trigger point
        delay: 0, // values from 0 to 3000, with step 50ms
        duration: 350, // values from 0 to 3000, with step 50ms
        easing: 'ease', // default easing for AOS animations
        once: true, // whether animation should happen only once - while scrolling down
        mirror: false, // whether elements should animate out while scrolling past them
        anchorPlacement: 'top-center', // defines which position of the element regarding to window should trigger the animation
      });
    }, 500);
    
  }

  if (window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {
    $('body').removeClass('animation--out');
  }

  // $( window ).on('beforeunload', function (e) {
  //   // HandleBackFunctionality();
  //   $('body').addClass('animation--out');
  // } );

  
 
  $('.js-slider').slick({
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    nextArrow: '<i class="far fa-arrow-right"></i>',
    prevArrow: '<i class="far fa-arrow-left"></i>',
    
  });
  
  $('.js-slider-news').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 2,
    nextArrow: '<i class="far fa-arrow-right"></i>',
    prevArrow: '<i class="far fa-arrow-left"></i>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
	
  // $( ".feuilles--left" ).append( `<div id="scene"><svg class="feuille" width="99" height="97" viewBox="0 0 99 97" fill="none" xmlns="http://www.w3.org/2000/svg">
  // <path d="M98.9946 92.0227C98.9946 90.4574 95.7156 53.4342 70.4395 28.2529L69.9613 27.7765C44.2071 2.59525 6.49792 0.0771405 4.92671 0.00908639C4.26089 -0.0321962 3.59386 0.067787 2.96972 0.302429C2.34557 0.537071 1.77853 0.901009 1.30608 1.37022C0.857604 1.85375 0.51153 2.42237 0.288523 3.04211C0.065517 3.66184 -0.0298482 4.32001 0.00812218 4.97727C0.00812225 6.54259 3.28718 43.5658 28.5632 68.679L29.1098 69.2235C54.7957 94.4047 92.5049 96.8548 94.0761 96.9909C94.7419 97.0322 95.4089 96.9322 96.0331 96.6976C96.6572 96.4629 97.2242 96.099 97.6967 95.6298C98.5895 94.6448 99.056 93.3485 98.9946 92.0227Z" fill="#C6D76B"/>
  // </svg></div>` );
  
 
  // setTimeout(function(){ 
  //   $('#scene').each(function() {
  //     var scene = $(this);
  //     console.log(scene);
  //     var parallaxInstance = new Parallax(scene);
  //   });
  // }, 1000);

  $('body').addClass('nav-show nav-show-top');

  $('.burger').on('click', function(e) {
    $('body').toggleClass('nav--mobile-show');
  });
  
  $('.report__btn a').on('click', function(e) {
    e.preventDefault();
    $('.card--document').each(function(element) {
      console.log(element);
      $(this).removeClass('d-none');
    });
    $('.report__btn').addClass('d-none');
  });

  var prevScrollpos = window.pageYOffset;
  window.onscroll = function() {
    var st = $(this).scrollTop();

    var currentScrollPos = window.pageYOffset;
    if (prevScrollpos > currentScrollPos || currentScrollPos == 0) {
      if(currentScrollPos < 700) {
        $('body').addClass('nav-show nav-show-top');
      } else {
        $('body').addClass('nav-show');
      }
    } else {
      if(currentScrollPos > 700) {
        $('body').removeClass('nav-show nav-show-top');
      }
    }
    prevScrollpos = currentScrollPos;
  }

  $('.card--team').on('click', function(e) {
    // Add class to modal to show
    $('body').addClass('popup-team-open');
    // Get infos from the curent card click
    let pictures = $(this).find('.team__container img').attr('src');
    let name = $(this).find('.team__infos h4').html();
    let func = $(this).find('.team__infos span').html();
    let legend = $(this).attr('data-legend');
    let linkedin = $(this).attr('data-linkedin');

    // Push infos to modal
    $('.popup__infos h4').html(name);
    $('.popup__infos span').html(func);
    $('.popup__infos .popup__img').attr('src', pictures);
    $('.popup__content').html(legend);
    $('.team__popup .linkedin').attr('href', linkedin);

  });

  $('.team__popup .cross').on('click', function(e) {
    $('body').removeClass('popup-team-open');
  });

  $('.articles__cat__tax').on('click', 'a' ,function(e) {
    e.preventDefault();

    let href = $(this).attr('href');
   
    $('.articles__cat__tax a').each(function() {
      if($(this).hasClass('actif')) {
        $(this).removeClass('actif');
      }
    });
    $(this).addClass('actif');
    console.log(href);
    $.ajax(href + '&paged=1')
        .done(function(data) {
          //get next article and push at the end
          $('.articles__container').html('');
          let targetArticle = $(data).find('.articles__container').html();
          $('.articles__container').append( targetArticle );          
        })
        .fail(function(jqxhr) {
            alert(jqxhr.responseText);
        });
  });

  $('.pagination__list__el').on('click', 'a' ,function(e) {
    e.preventDefault();

    let href = $(this).attr('href');
   
    $('.pagination__list__el a').each(function() {
      if($(this).hasClass('actif')) {
        $(this).removeClass('actif');
      }
    });
    $(this).addClass('actif');
    $.ajax(href)
        .done(function(data) {
          //get next article and push at the end
          $('.articles__container').html('');
          let targetArticle = $(data).find('.articles__container').html();
          $('.articles__container').append( targetArticle );          
        })
        .fail(function(jqxhr) {
            alert(jqxhr.responseText);
        });
  });


  $('.btn-modal').on('click', 'a' ,function(e) {
    e.preventDefault();
    $('body').addClass('graph--open');
    $('.section--graph').on('click', '.cross' ,function(e) {  
      $('body').removeClass('graph--open');
    });
  });

  
  $('#input_3_12').on('click', function(e) {
    $('.ginput_container_fileupload').addClass('uploaded');
  });
  

});
